<div class="white-box" *ngIf="project">
    <div class="row">
        <h4 class="medium-h mx-2 my-2">{{'Project Details' | translator}}</h4>
        <div class="col-md-3 col-12">
            <div class="detail-box-pg-4-header">
                <div class="row m-0 p-0 d-flex align-items-center">
                    <div class="col-4 m-0 p-0 d-flex justify-content-start">
                        <div class="project-title-pg-4">
                            {{'Project Name' | translator}}
                        </div>
                    </div>
                    <div class="col-8 m-0 p-0 d-flex justify-content-center">
                        <div class="project-name-pg-4">
                            {{project.name}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-12">
            <div class="detail-box-pg-4-header">
                <div class="row m-0 p-0 d-flex align-items-center">
                    <div class="col-md-4 col-12 m-0 p-0 d-flex justify-content-start">
                        <div class="project-title-pg-4">
                            {{'Start Date' | translator}} / {{'End Date' | translator}}
                        </div>
                    </div>
                    <div class="col-md-8 col-12 m-0 p-0 d-flex justify-content-center">
                        <div class="project-name-pg-4">
                            <div class="d-flex justify-content-between mob-my-2-pg-4">
                                <div>{{project.startDate | date}}</div>
                                <div class="d-flex align-items-center mx-2">
                                    <i class="full-stop"></i>
                                    <div class="time-bar"></div>
                                    <i class="pi pi-arrow-left icon-purple"></i>
                                </div>
                                <div>{{project.endDate | date}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-12">
            <div class="detail-box-pg-4-header">
                <div class="row m-0 p-0 d-flex align-items-center">
                    <div class="col-4 m-0 p-0 d-flex justify-content-start">
                        <div class="project-title-pg-4">
                            {{'Channels' | translator}}
                        </div>
                    </div>
                    <div class="col-8 m-0 p-0 d-flex justify-content-center">
                        <div class="project-name-pg-4" *ngFor="let channel of channels">
                            {{channel.name | translator}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div [hidden]="branches[0] == null" class="col-md-12 col-12 mt-2 align-content-center justify-content-center">
            <div class="detail-box-pg-4-header" style="width: fit-content;">
                <div class="m-0 p-0 d-flex gap-4 align-items-center">
                    <div class="m-0 p-0 d-flex justify-content-start">
                        <div class="project-title-pg-4">
                            {{'Branches' | translator}}
                        </div>
                    </div>
                    <div class="m-0 p-0 d-flex justify-content-center gap-2">
                        <div class="project-name-pg-4" *ngFor="let branch of branches">
                            {{branch.name}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>